<script setup lang="ts">
import { initFlowbite } from 'flowbite';
import { useStoryblokVersion } from '~/composables/use-storyblok-version';

const { params } = useRoute();
const { slug } = params;
const { locale } = useI18n();
// From legacy urls we may get calls that include the ad type or country, but let's just ignore that
const adId = slug && Array.isArray(slug) && slug.length > 0 ? slug[0] : undefined;
const story = await useAsyncStoryblok('ad/slug', {
    version: useStoryblokVersion(),
    language: locale.value,
});
onMounted(() => {
    initFlowbite();
});
</script>
<template>
    <StoryblokComponent v-if="story" :blok="{ ...story.content, adId: adId }" />
</template>
